
import React, { useState } from 'react';
import { Card, CardHeader, CardContent } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import SystemConfigHeader from './system/SystemConfigHeader';
import GeneralSystemSettings from './system/GeneralSystemSettings';
import AlertConfiguration from './system/AlertConfiguration';
import ScadaConnectorSettings from './system/ScadaConnectorSettings';

interface SystemConfigurationProps {
  editing: boolean;
  onEditToggle: () => void;
  onSave: () => void;
}

const SystemConfiguration: React.FC<SystemConfigurationProps> = ({ 
  editing, 
  onEditToggle, 
  onSave 
}) => {
  const [activeTab, setActiveTab] = useState('general');

  return (
    <Card>
      <CardHeader className="pb-2">
        <SystemConfigHeader
          editing={editing}
          onEditToggle={onEditToggle}
          onSave={onSave}
        />
      </CardHeader>
      <CardContent className="space-y-6">
        <Tabs value={activeTab} onValueChange={setActiveTab} className="space-y-4">
          <TabsList className="grid grid-cols-3 sm:w-auto w-full">
            <TabsTrigger value="general">General</TabsTrigger>
            <TabsTrigger value="alerts">Alerts</TabsTrigger>
            <TabsTrigger value="connectors">SCADA Connectors</TabsTrigger>
          </TabsList>
          
          <TabsContent value="general" className="space-y-6">
            <GeneralSystemSettings editing={editing} />
          </TabsContent>
          
          <TabsContent value="alerts" className="space-y-6">
            <AlertConfiguration editing={editing} />
          </TabsContent>
          
          <TabsContent value="connectors" className="space-y-6">
            <ScadaConnectorSettings editing={editing} />
          </TabsContent>
        </Tabs>
      </CardContent>
    </Card>
  );
};

export default SystemConfiguration;
